import { useCallback, useState } from 'react'

import Formsy from 'formsy-react'
import {
  Button,
  DefaultPopover,
  FormGroup,
  Label,
  Select,
  Separator,
} from 'twyne-new.ui'

import Input from 'components/form/Input'

import { useCustomReportStore } from '../store'
import { COLLECTIONS } from '../utils/constants'

export const ADD_BUTTON_ID = 'custom-report-add-btn'

export default function CreateReportViewPopover({ open, onOpenChange }) {
  const { activeView: { create } } = useCustomReportStore()
  const [collection, setCollection] = useState(COLLECTIONS[0]?.value || 'impression')

  const handleOpenChange = useCallback(isOpen => {
    onOpenChange(isOpen)
    if (isOpen) setCollection(COLLECTIONS[0]?.value || 'impression')
  }, [onOpenChange])

  const handleSubmit = useCallback(async model => {
    const id = await create(model.description, collection)
    if (id) onOpenChange(false)
  }, [create, collection, onOpenChange])

  return (
    <DefaultPopover
      title="New custom report"
      target={`#${ADD_BUTTON_ID}`}
      wrapperProps={{ open, onOpenChange: handleOpenChange }}
      triggerProps={{ asChild: true }}
      contentProps={{
        className: 'w-80 p-4',
        align: 'center',
        side: 'right',
        sideOffset: 8,
        onFocusOutside: event => event.preventDefault(),
      }}
    >
      <Formsy onValidSubmit={handleSubmit}>
        <div className="flex flex-col gap-4" data-custom-report-popover>
          <FormGroup>
            <Label>Description</Label>
            <Input name="description" required placeholder="Report name" />
          </FormGroup>
          <FormGroup>
            <Label>Collection</Label>
            <Select
              options={COLLECTIONS}
              value={collection}
              onChange={option => setCollection(option?.value || collection)}
              placeholder="Select collection"
            />
          </FormGroup>
          <Separator className="my-0" />
          <div className="flex justify-end gap-2">
            <Button size="sm" variant="ghost" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button size="sm" color="accent" type="submit">
              Create
            </Button>
          </div>
        </div>
      </Formsy>
    </DefaultPopover>
  )
}
